import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-product-compare-modal',
  templateUrl: './product-compare-modal.component.html',
  styleUrls: ['./product-compare-modal.component.scss'],
  standalone: false,
})
export class ProductCompareModalComponent implements OnInit {
  private admnSrvc = inject(AdminService);
  private dialogRef = inject<MatDialogRef<ProductCompareModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  changeDates = this.data.changeDates;
  runCounts = this.data.runCounts;
  dialogTitle = '';
  gridRows;
  highlightExclusions = ['ChangeID', 'DateTime'];
  moreDataVisible = false;

  ngOnInit() {
    const { productCode, profileId, solution, changeIDs } = this.data;
    const changeHistoryData = {
      ProfileID: profileId,
      ProductCode: productCode,
      ChangeID: changeIDs,
    };

    this.admnSrvc
      .getProductChangeHistory(changeHistoryData, solution)
      .subscribe(({ productName, rows }) => {
        this.dialogTitle = productName;
        this.gridRows = rows;
      });
  }

  toggleMoreData() {
    if (this.moreDataVisible) {
      this.moreDataVisible = false;
      this.gridRows = this.gridRows.filter(changeRow => changeRow.fieldName);
    } else {
      this.moreDataVisible = true;
      const { profileId, solution } = this.data;
      const changeDates = this.gridRows.find(
        changeRow => changeRow.fieldName === 'DateTime'
      )?.Values;

      const changeHistoryData = {
        profileId,
        startDate: changeDates[0],
        endDate: changeDates[1],
      };

      this.admnSrvc
        .getSimpleChangeHistory(changeHistoryData, solution)
        .subscribe(({ rows }) => {
          this.gridRows = this.gridRows.concat(rows);
        });
    }
  }

  close() {
    this.dialogRef.close({ data: 'cancel' });
  }

  findDisplayValue(value, row) {
    const values = value.includes(', ') ? value.split(', ') : [value];

    const displayValues = values.map(val => {
      const index = row.DisplayMapping.findIndex(
        displayVal => displayVal === val
      );
      if (index >= 0) {
        return row.Display[index];
      } else {
        return val;
      }
    });

    return displayValues.join(', ');
  }

  showRow(rowItem) {
    let showRowFlag = false;
    const invalidValues = ['0', 'N/A', '1/1/0001 12:00:00 AM', '1/1/1900'];

    if (rowItem.Values) {
      rowItem.Values.map(rowVal => {
        if (rowVal && !invalidValues.includes(rowVal)) {
          showRowFlag = true;
        }
      });
    }

    if (
      !showRowFlag &&
      (rowItem.hideIfEmpty === 'false' || !rowItem.hideIfEmpty)
    ) {
      showRowFlag = true;
    }

    return showRowFlag;
  }

  highlightRow(row, fieldName, index) {
    let rowValues;

    if (row.Values) {
      rowValues = row.Values;
    } else if (row.values) {
      rowValues = row.values;
    }

    if (
      this.data.changeIDs.length > 1 &&
      !this.highlightExclusions.includes(fieldName)
    ) {
      if (rowValues && rowValues[index]) {
        if (index !== 0) {
          if (
            (rowValues[index - 1] &&
              rowValues[index - 1] !== rowValues[index]) ||
            (rowValues[index + 1] && rowValues[index + 1] !== rowValues[index])
          ) {
            return true;
          } else if (!rowValues[index - 1]) {
            return true;
          }
        } else if (index === 0) {
          if (!rowValues[index + 1]) {
            return true;
          }
          if (
            rowValues[index + 1] &&
            rowValues[index + 1] !== rowValues[index]
          ) {
            return true;
          }
        }
      } else if (
        rowValues &&
        !rowValues[index] &&
        (rowValues[index - 1] || rowValues[index + 1])
      ) {
        return true;
      }
    }
    return false;
  }
}
